/** While the game stays open, it looks for a new release this often. */
const UPDATE_CHECK_MS = 60 * 60 * 1000;

/**
 * Registers the service worker and keeps the game up to date. Browsers only look for a new worker
 * on a page load, and a game kept on a phone's home screen mostly resumes from the background, so
 * it also looks on every resume and once an hour. A new release takes over by itself, and the page
 * then reloads the next time the menu shows: never in the middle of a round.
 */
export function watchForUpdates(): void {
	const { serviceWorker } = navigator;
	if (!serviceWorker) return;

	let controlled = serviceWorker.controller !== null;
	let updateReady = false;
	const reloadAtMenu = () => {
		if (!updateReady || document.body.dataset.screen !== "menu") return;
		updateReady = false;
		window.location.reload();
	};
	serviceWorker.addEventListener("controllerchange", () => {
		// A first worker taking over an uncontrolled page brings nothing new.
		updateReady = controlled;
		controlled = true;
		reloadAtMenu();
	});
	new MutationObserver(reloadAtMenu).observe(document.body, {
		attributes: true,
		attributeFilter: ["data-screen"],
	});

	void serviceWorker.register("./sw.js").then((registration) => {
		// Offline, or the server is restarting: the next check tries again.
		const check = () => void registration.update().catch(() => {});
		document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "visible") check();
		});
		window.setInterval(check, UPDATE_CHECK_MS);
	});
}
